// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__14tzQ","insightsList":"newBusinessInsightsMenu_insightsList__27Y5U","active":"newBusinessInsightsMenu_active__2RF1N"};